module.exports = __webpack_public_path__ + "files/8e956dd8d652ba817dcd9d36b82340ff.png";